import { useEffect } from "react";
import { CONSULTATION_URL } from "@/data/constants";
import { trackConversion } from "@/hooks/useSiteAnalytics";

/**
 * FLOWTALIS™ external booking redirect.
 * All internal /book-consultation navigation is forwarded to the
 * official Cal.com booking page in a new tab (target="_blank" via
 * window.open) so no legacy deep-link is ever stranded on a form.
 */
const BookConsultation = () => {
  useEffect(() => {
    // Fire conversion the moment the redirect page mounts — this is a
    // stronger signal than a raw CTA click (user landed on our booking route).
    trackConversion("consult_booked", { source: "book-consultation-redirect" });
    // Open Cal.com in a new tab. If the popup is blocked, redirect the
    // current tab. Either way the fallback screen with the manual link
    // stays visible so users on slow connections always see a booking CTA.
    const win = window.open(CONSULTATION_URL, "_blank", "noopener,noreferrer");
    if (!win) {
      window.location.replace(CONSULTATION_URL);
    }
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white" data-testid="consult-redirect">
      <div className="text-center px-6">
        <div className="text-[0.6875rem] uppercase tracking-[0.32em] text-[var(--ft-gold)] font-semibold mb-4">
          Booking
        </div>
        <h1 className="text-2xl font-bold text-[var(--ft-black)] mb-3">
          Opening your consultation booking…
        </h1>
        <p className="text-[var(--ft-muted)] mb-6 text-sm">
          If a new tab did not open, use the link below.
        </p>
        <a
          href={CONSULTATION_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="ft-btn-gold"
          data-testid="consult-redirect-link"
        >
          Book Your Consultation
        </a>
      </div>
    </div>
  );
};

export default BookConsultation;
